import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../models/app-config';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private appConfig: AppConfig;

    constructor(private http: HttpClient) { }

    loadAppConfig(): Promise<any> {
        const promise = this.http.get('./appConfig.json', { responseType: 'text' }).toPromise();

        promise
            .then(data => {
                this.appConfig = <AppConfig>JSON.parse(data);
            }).catch(() => {
                console.warn('Error loading app-config.json');
            });

        return promise;
    }

    initAppConfigForTests() {
        return this.http.get('./appConfig.json', { responseType: 'text' });
    }

    get config(): AppConfig {
        return this.appConfig;
    }
}
